// BREAKPOINTS
export const TINY_BREAK = 540; // only for layout changes
export const SMALL_BREAK = 740; // aside appears
export const MEDIUM_BREAK = 1024; // small nav appears
export const LARGE_BREAK = 1268; // wide nav appears

export const NUM_COLS = 12;
export const GUTTER = 16;
export const PADDING_LOGGED_OUT = 20;
export const MAIN_GAP = 44;
export const ASIDE_MIN = 244;
export const MIN_WIDTH = 320;

const WIDTH_LOGGED_OUT = 1260;
const WIDTH_LARGE = 944;
const WIDTH_NARROW = 596;

const MEDIA_TINY = `@media (max-width: ${TINY_BREAK - 1}px)`;
const MEDIA_SMALL = `@media (min-width: ${TINY_BREAK}px)`;
const MEDIA_MEDIUM = `@media (min-width: ${SMALL_BREAK}px)`;
const MEDIA_LARGE = `@media (min-width: ${MEDIUM_BREAK}px)`;
const MEDIA_EXPANDED = `@media (min-width: ${LARGE_BREAK}px)`;

const propsNames = <T extends string>(
  name: T
): {
  MEDIA_TINY: `${T}Tiny`;
  MEDIA_SMALL: T;
  MEDIA_MEDIUM: `${T}Medium`;
  MEDIA_LARGE: `${T}Large`;
  MEDIA_EXPANDED: `${T}Large`;
} => ({
  MEDIA_TINY: `${name}Tiny`,
  MEDIA_SMALL: name, // small is default
  MEDIA_MEDIUM: `${name}Medium`,
  MEDIA_LARGE: `${name}Large`,
  MEDIA_EXPANDED: `${name}Large`, // not used?
});

// hash maps for props $start and $span
export const PROPS_START = propsNames('$start');
export const PROPS_SPAN = propsNames('$span');

export const MEDIA_QUERIES = {
  MEDIA_TINY,
  MEDIA_SMALL,
  MEDIA_MEDIUM,
  MEDIA_LARGE,
  MEDIA_EXPANDED,
} as const;

export const MEDIA_QUERY_IDS = Object.keys(MEDIA_QUERIES).filter(
  (k): k is keyof typeof MEDIA_QUERIES => true
);

export const CONTAINER_WIDTHS = {
  LoggedOut: WIDTH_LOGGED_OUT,
  FullSize: WIDTH_LARGE,
  TwoCol: WIDTH_LARGE,
  Narrow: WIDTH_NARROW,
};
